<template>
  <div class="grid grid-cols-2 gap-3">
    <MobTextField label="Nombre" :value="displayName" :readonly="true" disabled/>
    <MobTextField v-model="form.dateBirth" label="Fecha de nacimiento" type="date"/>
    <div class="flex flex-col gap-1">
      <label class="text-sm font-medium">País</label>
      <select v-model="form.country" class="border rounded px-3 py-2 w-full">
        <option value="">Selecciona tu país</option>
        <option v-for="c in countryOptions" :key="c.code" :value="c.name">{{ c.name }}</option>
      </select>
    </div>
    <MobTextField v-model="form.department" label="Departamento/Estado/Provincia" />
    <MobTextField v-model="form.city" label="Ciudad" />
    <MobTextField label="Correo" :value="displayEmail" :readonly="true" disabled/>
    <MobTextField v-model="form.institution" label="Institución educativa" />
    <div class="flex flex-col gap-3">
      <p>Género</p>
      <div class="flex gap-2 pt-1">
        <div v-for="option in genderOptions" :key="option.value">
          <label>
            <input type="radio" :value="option.value" v-model="form.gender" />
            {{ option.label }}
          </label>
        </div>
      </div>
    </div>
    
    <div class="flex gap-3">
      <button v-on:click="onSubmit(userData2.id)" class="mob-btn mob-cta-gold">Actualizar</button>
    </div>

  </div>
</template>

<script>
import { MobTextField, MobRadio } from "@/views/V2/components/";
import { COUNTRIES_ES } from "@/constants/countries.es";
import axios from "axios";

export default {
  name: "UserSettingsForm",
  components: {
    MobTextField,
    MobRadio,
    options: {
      type: Array,
      required: true
    },
    inputName: {
      type: String,
      required: true
    }
  },
  props: {
    userData2: Object,
    reloadOnSuccess: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: {
        name: '',
        dateBirth: '',
        country: '',
        department:  '',
        city: '',
        email:  '',
        institution: '',
        gender: '',
      },
      genderOptions: [
        { label: "Femenino", value: "female" },
        { label: "Másculino", value: "male" },
        { label: "Otro", value: "other" },
      ],
      selectedGender: ''
    };
  },
  computed: {
    countryOptions() {
      return COUNTRIES_ES;
    },
    displayName() {
      if (this.userData2?.name) return this.userData2.name;
      if (this.form?.name) return this.form.name;
      return "No hay nombre";
    },
    displayEmail() {
      if (this.userData2?.email) return this.userData2.email;
      if (this.form?.email) return this.form.email;
      return "";
    },
  },
  methods: {
    onSubmit(id) {
      let loader = this.$loading.show({});
      // console.log("---------" + id );
      axios.put(import.meta.env.VITE_API_BASE_URL + "/user/editOptions/" + id , this.form, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        }}).then(() => {
        this.$toastr.s("Usuario Editado.");
        this.$emit("saved");
        loader.hide();
        if (this.reloadOnSuccess) {
          this.$router.go();
        }
      }).catch((err) => {
        loader.hide();
        console.log(err.message);
        this.$toasted.error("Error al editar el usuario, posiblemente ya exista alguna con los mismos datos y estado.", {position: 'top-right', duration: 5000});
      });
    },
  },
  watch: {
    userData2: {
      handler(newVal) {

        if (newVal && newVal.id) {
          let userId = newVal.id
          axios.get(
            import.meta.env.VITE_API_BASE_URL + "/user/getuser/" + userId,{
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              }
            }
          )
          .then((response) => {
            this.form.name = response.data.name;
            this.form.dateBirth = response.data.dateBirth;
            this.form.country = response.data.country;
            this.form.department = response.data.department;
            this.form.city = response.data.city;
            this.form.institution = response.data.institution;
            this.form.email = response.data.email;
            this.form.gender = response.data.gender;

            // console.log(response);
            // console.log(response);
          }).catch((err) => {
            // loader.hide();
            console.log("err");
            console.log(err.message);
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>